import MainOutlet from "Outlets/MainOutlet";
import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./HomePage/HomePage";
import PortfolioPage from "./PortfolioPage/PortfolioPage";
import ProjectPage from "./ProjectPage/ProjectPage";
import FilteredPage from "./FilteredPage/FilteredPage";
import AboutPage from "./AboutPage/AboutPage";

export const PortfolioSite = () => {
  return (
    <Routes>
      <Route path="/">
        <Route element={<MainOutlet />}>
          <Route index element={<HomePage />} />

          <Route path="/coding">
            <Route index element={<PortfolioPage />} />
            <Route path=":projectId" element={<ProjectPage />} />
          </Route>

          <Route path="/design">
            <Route index element={<PortfolioPage />} />
            <Route path=":projectId" element={<ProjectPage />} />
          </Route>

          <Route path="/photography">
            <Route index element={<PortfolioPage />} />
            <Route path=":projectId" element={<ProjectPage />} />
          </Route>

          <Route path="/search" element={<FilteredPage />} />

          <Route path="/about" element={<AboutPage />} />
        </Route>
      </Route>
    </Routes>
  );
};
